<template>
    <div class="messages-wrapper" :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`" ref="messagesWrapper">
        <div class="loader-parent" v-if="showMessageLoader">
            <div class="msg-loader"></div>
        </div>
        <template v-if="isError && !getAreConvMsgsLoading(activeConversation?.id)">
            <ErrorMessageHandler title="messages" :try-again="reset" />
        </template>
        <template v-if="getAreConvMsgsLoading(activeConversation?.id) && !isError">
            <div v-for="i in loadingCount" :key="i">
                <div class="message-row d-flex">
                    <div class="d-flex w-100">
                        <div class="ava-initials">
                            <span></span>
                        </div>
                        <div class="message-body w-35">
                            <span class="shimmer-loading w-90 lighten"></span>
                            <div class="message-content">
                                <span class="shimmer-loading w-60 lighten"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="message-row d-flex flex-row-reverse">
                    <div class="message-body w-35">
                        <span class="shimmer-loading w-90 lighten"></span>
                        <div class="message-content">
                            <span class="shimmer-loading w-60 lighten"></span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="!getAreConvMsgsLoading(activeConversation?.id) && !isError">
            <!-- READ MESSAGES -->
            <template v-for="(message, index) in readMessages" :key="message.id">
                <!-- DATE -->
                <div class="message-separator" v-if="showDateBanner(index)">
                    <span>{{ formatDateToLocalBasedOnDayMode(message.createdOn) }}</span>
                </div>
                <!-- MESSAGE -->
                <div
                    :class="`message-row d-flex ${message.isFromSelf ? 'flex-row-reverse' : 'flex-row'}`"
                    :ref="`${messageReferences[index]}`"
                >
                    <!-- IS FROM SELF -->
                    <UserMessage
                        :is-last-message="index === lastSelfMessageIndex"
                        :is-group-conversation="isGroupConversation"
                        :read-list="activeConversation?.readList || []"
                        v-if="message.isFromSelf"
                        :message="message"
                        :previous-message="readMessages[index - 1] || null"
                    />
                    <!-- FROM OTHERS -->
                    <OthersMessage v-else :message="message" :previous-message="readMessages[index - 1] || null" />
                </div>
            </template>
            <!-- BANNER -->
            <div
                class="message-separator unread"
                v-if="unReadMessages?.length > 0 && !unReadMessages[unReadMessages.length - 1].isFromSelf"
                ref="unReadMessagesBanner"
            >
                <span class="fw-bold">
                    {{ unReadMessages?.length }} Unread Message{{ unReadMessages?.length > 1 ? "s" : "" }}
                </span>
            </div>
            <!-- UNREAD MESSAGES -->
            <div class="message-row d-flex flex-row" v-for="(message, index) in unReadMessages" :key="message.id">
                <OthersMessage
                    :message="message"
                    :previous-message="unReadMessages[index - 1] || null"
                    v-if="!message.isFromSelf"
                />
            </div>
        </template>
    </div>
</template>

<style src="./MessagesRenderer.scss"></style>
<script lang="ts" src="./MessagesRenderer.ts"></script>
